import { Modal, Typography } from "antd";
import { ReactComponent as CloseIcon } from "../../../common/images/svg/CloseIcon.svg";
import { CustomButton } from "../../../components/button/buttonCustom";
import { ButtonTransparent } from "../../../components/button/buttonTransparent";
import LoadingOverlay from "../../../components/loading/loadingOverlay";
import TextContent from "../../../pages/history/component/form/text-content";
import useResponsive from "../../../utils/hooks/useResponsive";
import { formatNumber } from "../../../utils/list.utils";

interface ModalConfirmProps {
  open: any;
  handleCancelConfirm: () => void;
  onSubmitWithdraw: () => void;
  amountValue: any;
  currency: string;
  metadataNetwork: {
    value: string;
    label: string;
  }[];
  selectedNetwork: any;
  transferMode: string;
  addressValue: string;
  userCode: string;
  isLoading: boolean;
  failedMessage?: string;
  submitFee: string | number;
  warningChange: boolean;
  decimals: number | null;
  infoByUserCode: any;
}

const ModalConfirm = ({
  open,
  handleCancelConfirm,
  onSubmitWithdraw,
  amountValue,
  currency,
  metadataNetwork,
  selectedNetwork,
  transferMode,
  addressValue,
  userCode,
  isLoading,
  failedMessage,
  submitFee,
  warningChange,
  decimals,
  infoByUserCode,
}: ModalConfirmProps) => {
  const { isTablet } = useResponsive();

  return (
    <Modal
      open={open}
      onCancel={handleCancelConfirm}
      footer={null}
      destroyOnClose
      maskClosable={false}
      title={
        <>
          <Typography
            style={{
              fontSize: isTablet ? 16 : 20,
              fontWeight: 700,
              color: "#C2C6CE",
            }}
          >
            {`Review & Confirm Withdrawal`}
          </Typography>
          <CloseIcon onClick={handleCancelConfirm} className="icon-animation" />
        </>
      }
      className="send-money-modal"
    >
      <div>
        <div className="form-history fix-bottom">
          <div className="modal-balance">
            <div className="value-balance">
              <Typography style={{ fontSize: 16, color: "white" }}>
                Amount
              </Typography>
              <Typography.Text className={"text-gradient"}>
                {formatNumber(Number(amountValue), decimals || 4)}{" "}
                <Typography.Text
                  className="text-gradient"
                  style={{
                    fontSize: isTablet ? "20px" : "24px",
                    lineHeight: isTablet ? "20px" : "24px",
                  }}
                >
                  {currency}
                </Typography.Text>
              </Typography.Text>
            </div>
          </div>
          <div className="form-history-content">
            <TextContent
              label="Beneficiary Will Receive"
              value={`${formatNumber(
                String(Number(amountValue) - Number(submitFee)),
                decimals || 4
              )} ${currency}`}
              color="rgba(242, 138, 40, 1)"
            />
          </div>
          <div
            className="form-history-content border-top"
            style={{ gap: "24px" }}
          >
            <TextContent label="Currency" value={currency} />
            <TextContent
              label="Chain Type"
              value={
                transferMode === "SEND_VIA_CRYPTO_NETWORK"
                  ? metadataNetwork?.find(
                    (item: any) => item.value === selectedNetwork
                  )?.label || ""
                  : "SMART UID"
              }
            />
            <TextContent
              label={
                transferMode === "SEND_VIA_CRYPTO_NETWORK"
                  ? "Address"
                  : "Beneficiary"
              }
              value={
                transferMode === "SEND_VIA_CRYPTO_NETWORK"
                  ? addressValue
                  : `${userCode} (${infoByUserCode?.fullName || ""})`
              }
              canCopy={transferMode === "SEND_VIA_CRYPTO_NETWORK"}
            />
            <TextContent
              label="Fees"
              value={`${formatNumber(
                Number(submitFee),
                decimals || 4
              )} ${currency}`}
            />
          </div>
        </div>
        <div
          className="form-withdraw-button"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            paddingBottom: 10,
            paddingTop: 24,
          }}
        >
          {failedMessage ? (
            <Typography className="text-withdraw-failed">
              {failedMessage}
            </Typography>
          ) : null}
          <CustomButton
            size={isTablet ? "medium" : "large"}
            text={"Submit Withdrawal"}
            width={"100%"}
            onClick={onSubmitWithdraw}
            disabled={!!failedMessage}
            isLoading={isLoading}
          />
          <ButtonTransparent
            size={isTablet ? "small" : "medium"}
            text={"Back to edit"}
            width={"100%"}
            onClick={handleCancelConfirm}
            isLoading={isLoading}
            textClassName="text-button-back"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirm;
